import { render, staticRenderFns } from "./onlineRecord.vue?vue&type=template&id=87ab91cc&"
import script from "./onlineRecord.vue?vue&type=script&lang=js&"
export * from "./onlineRecord.vue?vue&type=script&lang=js&"
import style0 from "./onlineRecord.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports